import * as React from 'react'

import Box from '@mui/material/Box'

type Props = {
  children: React.ReactNode
}

export function BulkActionsFooter(props: Props) {
  const { children } = props

  return (
    <Box display="flex" alignItems="center" mt={1}>
      {children}
    </Box>
  )
}
